import HyperDX from '@hyperdx/browser';
import React, { FC, useEffect, useState } from 'react';
import Script from 'next/script';
import { ErrorBoundary } from 'react-error-boundary';
import { Provider } from 'react-redux';
import { FirebaseProvider } from '../src/components/FirebaseProvider';
import { AuthWrapper } from '../src/components/AuthWrapper';
import { ToastContainer } from 'react-toastify';
import { ScrollToTop } from '../src/components/common';

import * as config from '../src/config';
import { wrapper, rrfProps } from '../src/store';

import 'react-toastify/dist/ReactToastify.css';
import 'flag-icons/css/flag-icons.min.css';
import '../styles/globals.css';

import type { AppProps } from 'next/app';

if (config.HYPERDX_API_KEY) {
  HyperDX.init({
    advancedNetworkCapture: false,
    apiKey: config.HYPERDX_API_KEY,
    consoleCapture: true,
    maskAllInputs: false,
    maskAllText: false,
    service: 'pttbrain-app',
    tracePropagationTargets: [
      /localhost/i,
      /pttbrain-api\.herokuapp\.com/i,
      /pttbrain\.com/i,
    ],
  });

  HyperDX.attachToReactErrorBoundary(ErrorBoundary);
}

const MyApp: FC<AppProps> = ({ Component, ...rest }) => {
  const [isMounted, setIsMounted] = useState(false);

  const { store, props } = wrapper.useWrappedStore(rest);

  // Type assertion for Provider due to react-redux type compatibility
  const ReduxProvider = Provider as any;

  return (
    <ErrorBoundary fallback={<div>Something went wrong</div>}>
      <Script
        src="https://www.googletagmanager.com/gtag/js?id=G-57Y04TQGFN"
        strategy="afterInteractive"
      />
      <Script id="google-analytics" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){window.dataLayer.push(arguments);}
          gtag('js', new Date());

          gtag('config', 'G-57Y04TQGFN');
        `}
      </Script>
      <ReduxProvider store={store}>
        <FirebaseProvider {...rrfProps} dispatch={store.dispatch}>
          <AuthWrapper>
            <ToastContainer position="bottom-right" theme="light" />
            <Component {...props.pageProps} />
            <ScrollToTop />
          </AuthWrapper>
        </FirebaseProvider>
      </ReduxProvider>
    </ErrorBoundary>
  );
};

export default MyApp;
